import { PropsWithChildren, useState } from 'react'
import { LandReportMapDataLayer, LandReportViewContext } from './LandReportViewContext'

const CURRENT_YEAR = new Date().getFullYear()

export const LandReportViewProvider = ({ children }: PropsWithChildren<object>) => {
  const [focusYear, setFocusYear] = useState<number>(CURRENT_YEAR)
  const [dataLayer, setDataLayer] = useState<LandReportMapDataLayer>(LandReportMapDataLayer.ACRES)

  return (
    <LandReportViewContext.Provider
      value={{
        dataLayer,
        focusYear,
        setDataLayer,
        setFocusYear,
      }}
    >
      {children}
    </LandReportViewContext.Provider>
  )
}
